/** Shared phone glyph for the brief's shoot controls. */
export default function PhoneIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 16 16" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="4" y="1.5" width="8" height="13" rx="2" />
      <circle cx="8" cy="11.5" r="0.5" />
    </svg>
  );
}
